import { render, staticRenderFns } from "./IconWarningYellow.vue?vue&type=template&id=553d51ba"
import script from "./IconWarningYellow.vue?vue&type=script&lang=js"
export * from "./IconWarningYellow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports